<!--<head>-->
<!--    <script type="text/javascript">-->
<!--        function preventBack() { window.history.forward(); }-->
<!--        setTimeout("preventBack()", 0);-->
<!--        window.onunload = function () { null };-->
<!--    </script>-->
<!--    <script src="answering.component.ts"></script>-->
<!--</head>-->
<div *ngIf="commondata.loader.value" id="pre-loader">
    <img alt="" src="assets/images/pre-loader/loader-01.svg">
</div>
<div class="container-fluid" id="yourTarget">

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="card-body {{env.deviceType() ? 'px-3 py-2' : ''}}">
                            <div class="row pr-3 my-1 d-flex align-items-center">
                                <div class="col-md-6 mt-2">
                                    <h4 class="contenttext mb-0">{{contentName}}</h4>
                                </div>
                                <div class="col-md-6 px-0 pdf-assign-btn d-flex align-items-center justify-content-end">
                                    <div class="row my-0 mx-2 justify-content-center" *ngIf="isSingleQnsWithFeedbackType">
                                        <div class="w-auto text-center">
                                            <h4 style="font-size: 24px" class="mb-0" *ngIf="getElapsedTime() as elapsed"><b>{{elapsed.hours}}</b></h4>
                                            <h6 style="font-size: 12px" class="color-primary mb-0">Hours</h6>
                                        </div>
                                        <div class="w-auto align-content-center mx-2">
                                            <h4 class="mb-0 font-weight-bold">:</h4>
                                        </div>
                                        <div class="w-auto text-center">
                                            <h4 style="font-size: 24px" class="mb-0" *ngIf="getElapsedTime() as elapsed"><b>{{elapsed.minutes}}</b></h4>
                                            <h6 style="font-size: 12px"  class="color-primary mb-0">Minutes</h6>
                                        </div>
                                        <div class="w-auto align-content-center mx-2">
                                            <h4 class="mb-0 font-weight-bold">:</h4>
                                        </div>
                                        <div class="w-auto text-center">
                                            <h4 style="font-size: 24px" class="mb-0" *ngIf="getElapsedTime() as elapsed"><b>{{elapsed.seconds}}</b></h4>
                                            <h6 style="font-size: 12px" class="color-primary mb-0">Seconds</h6>
                                        </div>
                                    </div>
                                    <div class="row mx-2">
                                        <div ngbDropdown container="body">
                                            <i style="font-size: 24px !important;" id="gfg2" *ngIf="showUploadFile && functionCalled && !expandPdf" ngbDropdownToggle
                                               [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                               class="fa fa-upload color-primary icon d-inline-flex" aria-hidden="true" title="Upload PDF">
                                                <div class="ml-3" *ngIf="answerPdf.length != 0">
                                                    <span class="upload-count">({{answerPdf.length}})</span>
                                                </div>
                                                <div ngbDropdownMenu="gfg2">
                                                    <div class="col-md-12 text-center" *ngIf="answerPdf.length == 0">
                                                        <label class="px-2 mb-0 color-primary">No PDF File Uploaded</label>
                                                    </div>
                                                    <div class="col-md-12 px-0 justify-content-between align-items-center d-flex"
                                                         *ngFor="let item of answerPdf; let i = index">
                                                        <label class="px-2 mb-0 color-primary" ngbDropdownItem>{{item.image}}</label>
                                                        <i (click)="deletePdf(i)"
                                                           [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                           aria-hidden="true" class="fa fa-close px-3" style="cursor:pointer"></i>
                                                    </div>
                                                    <div class="col-md-12 d-flex justify-content-center mt-2" *ngIf="showUploadFile">
                                                        <input #hiddenfileinput (change)="encodePdfFileAsURL($event)" accept=".pdf"
                                                               multiple style="display: none" type="file">
                                                        <button (click)="hiddenfileinput.click()"
                                                                [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                                aria-describedby="inputGroupFileAddon01"
                                                                class="btn-sm btn-outline-primary mb-2 ml-2 pull-right button1"
                                                                type="file">Upload pdf
                                                        </button>
                                                    </div>
                                                </div>
                                            </i>
                                        </div>
                                            <a *ngIf="questionData?.download != '0' && !expandPdf && functionCalled"
                                                [download]="downloadTemplateName" [href]="downloadTemplate">
                                                <i class="fa fa-download color-primary icon" title="Download PDF" aria-hidden="true"></i>
                                            </a>
                                            <i *ngIf="questionData?.teacher_feedback != '' && questionData?.teacher_feedback && functionCalled && !expandPdf"
                                                title="Teacher Feedback" class="fa fa-commenting-o icon color-primary" aria-hidden="true" (click)="showFeedback()"></i>
                                            <img *ngIf="linkdata?.length != '0'" style="border: 1px solid #8F008A; border-radius: 4px; padding: 0; width: 34px; height: 34px; margin-right: 12px" alt="Resource"
                                                 src="assets/images/mob-side-icon/books.png" title="Resources" (click)="otherlink()">
                                            <i title="Save & Exit" (click)="saveAnswer('2', 'exit', true, 'same')"
                                                *ngIf="(getData.student_content_status == '1' || getData.student_content_status == '2') && !isSingleQnsWithFeedbackType"
                                               class="fa fa-sign-out color-primary icon" aria-hidden="true"></i>
                                            <i title="Save" (click)="saveAnswer('2', 'noExit', true, 'same')" *ngIf="(getData.student_content_status == '1' || getData.student_content_status == '2') && !isSingleQnsWithFeedbackType"
                                                class="fa fa-floppy-o color-primary icon" aria-hidden="true"></i>
                                            <button (click)="buttonClicked = 'submit';submitPopup()"
                                                *ngIf="(getData.student_content_status == '1' || getData.student_content_status == '2') && !isSingleQnsWithFeedbackType"
                                                class="btn btn-primary pull-right {{env.deviceType() ? 'border-radius-5' : ''}}">Submit
                                            </button>
                                        <!--                    <button (click)="saveAnswer('2', 'noExit', true, 'same')" *ngIf="getData.student_content_status == '1' || getData.student_content_status == '2'" class="btn btn-outline-primary pull-right ml-2">Save</button>-->
                                        <!--                    <button (click)="saveAnswer('2', 'exit', true, 'same')" *ngIf="getData.student_content_status == '1' || getData.student_content_status == '2'" class="btn btn-outline-primary pull-right">Save and Exit</button>-->
                                        <!--                    <button *ngIf="linkdata?.length != '0'" class="btn btn-primary pull-right mx-2" (click)="otherlink()">Resources</button>-->
                                            <button (click)="backbutton()" *ngIf="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                class="btn btn-outline-primary pull-right ml-2 {{env.deviceType() ? 'border-radius-5' : ''}}">Back
                                            </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--    <div *ngIf="showpdf" class="row">-->
    <!--        <div class="col-md-12 px-0 d-flex justify-content-end mb-3">-->
    <!--            <select (change)="sectionFilter($event)" *ngIf="totalAnsSample.length > 1 && !expandPdf" [(ngModel)]="sectionFilterVal" class="form-span col-md-4">-->
    <!--                <option value="all">All Section</option>-->
    <!--                <option *ngFor="let item of totalAnsSample; let i = index" value="{{i}}">{{item.heading}}</option>-->
    <!--            </select>-->
    <!--            <div class="col-md-3 px-0">-->
    <!--                <div *ngIf="totalAnsSample.length > 0 && showAutoScroll" class="col-md-12 px-0 d-flex justify-content-end align-items-center">-->
    <!--                    <input (change)="allowAutoScroll = !allowAutoScroll" [checked]="allowAutoScroll" type="checkbox"><label class="ml-2 mb-0"><b>Auto scroll</b></label>-->
    <!--                </div>-->
    <!--                <small *ngIf="showUploadFile" [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'"-->
    <!--                       class="col-md-12 px-0 d-flex justify-content-end"-->
    <!--                       style="color: grey; font-weight: bold; align-self: end">Note: Upload PDF size should not exceed {{this.uploadFileSize.toString()}} MB</small>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->

    <div *ngIf="showpdf" class="row">
        <!--        <div *ngIf="functionCalled && answerPdf.length > 0" class="col-md-12 px-0 d-flex flex-wrap justify-content-start flex-row-reverse">-->
        <!--            <div *ngFor="let item of answerPdf; let i = index" class="col-md-4 pr-0">-->
        <!--                <div class="col-md-12 justify-content-between align-items-center custom-card d-flex mt-2 mb-2">-->
        <!--                    <label class="px-2 mb-0 color-primary">{{item.image}}</label>-->
        <!--                    <i (click)="deletePdf(i)" [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'" aria-hidden="true" class="fa fa-close px-3" style="cursor:pointer"></i>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="col-md-{{expandPdf ? '12' : '8'}}">
<!--            <div *ngIf="(getData.student_content_status == '1' || getData.student_content_status == '2') && !env.deviceType() && showWorkArea">-->
<!--                <app-annotation (annotate)="getWorkAreaAnnotation($event)"-->
<!--                                [getAnnotate]="workAnnotate"-->
<!--                                [id]="'workArea'"-->
<!--                                [toolAdjust]="true"-->
<!--                                [toolHide]="true"-->
<!--                                [userType]="'student'"></app-annotation>-->
<!--            </div>-->
            <div *ngIf="!functionCalled" id="custom-pdf-loader" style="height: 100vh;">
                <img alt="" src="assets/images/pre-loader/loader-01.svg">
            </div>
            <div class="col-md-12" *ngIf="pdf && functionCalled && !isPdfAvailable">
                <app-source-link [pdfPath]="pdfPath[0]"></app-source-link>
            </div>
            <app-annotation *ngIf="pdf && functionCalled && isPdfAvailable && !env.deviceType()"
                            [getAnnotate]="areaInfo"
                            [userType]="'student'"
                            (annotate)="getAreaInfo($event)"
                            (deleteAnnotation)="getDeleteAction($event)"
                            (currentPageNo)="getCurrentPageNo($event)"
                            (expandBoolean)="expandPdfSize($event)"
                            [pageVariable]="scrolledPageNumber"
                            [showPageNo]="showAutoScroll"
                            [pdfPath]="pdfTemplate"
                            [expandPdf]="true"
                            [getDragQues]="dragQuestion"
                            [toolHide]="getData.student_content_status != '1' && getData.student_content_status != '2'"></app-annotation>

            <app-student-web-annotation *ngIf="pdf && functionCalled && isPdfAvailable && env.deviceType()"
                                        [expandPdf]="true"
                                        (expandBoolean)="expandPdfSize($event)"
                                        [overallData]="overallFullData"
            ></app-student-web-annotation>
        </div>
        <div *ngIf="functionCalled && !expandPdf" class="col-md-{{pdf == true ? 4 : 12}} px-0">
            <div class="col-md-12 px-0 d-flex justify-content-between {{env.deviceType() ? 'align-items-center' : ''}} ">
                <div *ngIf="totalAns.length != 0" class="col-md-1 px-0 {{env.deviceType() ? 'mb-2' : ''}}">
                    <img (click)="showPdf()" *ngIf="!pdf" alt=""
                         class="mt-1 {{env.deviceType() ? 'question-side-icon' : ''}}"
                         src="assets/images/pdf-icons/arrowRight.png" title="Show pdf">
                    <img (click)="showPdf()" *ngIf="pdf" alt=""
                         class="mt-1 {{env.deviceType() ? 'question-side-icon' : ''}}"
                         src="assets/images/pdf-icons/arrowLeft.png" title="Hide pdf">
                </div>
                <div *ngIf="showpdf"
                     class="col-md-{{totalAns.length != 0 ? '11' : '12'}} pl-0 pr-3 my-2 d-flex justify-content-end align-items-center">
                    <!--                    <div *ngIf="questionData?.teacher_feedback">-->
                    <!--                        <div *ngIf="questionData?.teacher_feedback != ''" class="d-flex justify-content-end">-->
                    <!--                            <button [attr.aria-controls]="'#teacherFeed'" [attr.data-target]="'#teacherFeed'" aria-expanded="false" class="btn-sm btn-outline-primary" data-toggle="collapse">Teacher Feedback</button>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <select (change)="sectionFilter($event)" *ngIf="totalAnsSample.length > 1 && !expandPdf"
                            [(ngModel)]="sectionFilterVal"
                            class="form-span col-md-{{totalAnsSample.length > 0 && showAutoScroll ? '8' : '12'}}">
                        <option value="all">All Section</option>
                        <option *ngFor="let item of totalAnsSample; let i = index"
                                value="{{i}}">{{item.heading}}</option>
                    </select>
                    <div class="col-md-4 px-0" *ngIf="totalAnsSample.length > 0 && showAutoScroll">
                        <div class="col-md-12 px-0 d-flex justify-content-end align-items-center">
                            <input (change)="allowAutoScroll = !allowAutoScroll" [checked]="allowAutoScroll"
                                   type="checkbox"><label class="ml-2 mb-0"><b>Auto scroll</b></label>
                        </div>
                    </div>
                    <!--                    <input #hiddenfileinput (change)="encodePdfFileAsURL($event)" accept=".pdf" multiple style="display: none" type="file">-->
                    <!--                    <button (click)="hiddenfileinput.click()" *ngIf="showUploadFile" [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'" aria-describedby="inputGroupFileAddon01"-->
                    <!--                            class="btn-sm btn-outline-primary mb-2 ml-2 pull-right button1"  type="file">Upload pdf</button>-->
                    <!--                    <a *ngIf="questionData?.download != '0'" [download]="downloadTemplateName" [href]="downloadTemplate"  class="button ml-2 pull-right">Download Pdf</a>-->
                </div>
            </div>
            <div class="col-md-12 mb-2" *ngIf="showUploadFile && showpdf">
                <small [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                       class="col-md-12 px-0 d-flex justify-content-end"
                       style="color: grey; font-weight: bold; align-self: end">Note: Upload PDF size should not
                    exceed {{uploadFileSize.toString()}} MB</small>
            </div>
            <!--            <div *ngIf="questionData.teacher_feedback != ''" class="row mt-3 mb-3 px-3">-->
            <!--                <div class="col-md-12 px-0 collapse" id="teacherFeed">-->
            <!--                    <div class="col-md-12 px-0">-->
            <!--                        <div class="col-md-12 customize-card4">{{questionData.teacher_feedback}}</div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="col-md-12 px-0">-->
            <!--                <div *ngFor="let item of answerPdf; let i = index" class="col-md-12 justify-content-between align-items-center custom-card d-flex mt-2 mb-2">-->
            <!--                    <label class="px-2 mb-0 color-primary">{{item.image}}</label>-->
            <!--                    <i (click)="deletePdf(i)" [hidden]="getData.student_content_status != '1' && getData.student_content_status != '2'" aria-hidden="true" class="fa fa-close px-3" style="cursor:pointer"></i>-->
            <!--                </div>-->
            <!--            </div>-->
            <div *ngIf="questionData.answers.length != 0" class="col-12 px-0 view-question">
                <div (scrolled)="onScrollDown()"
                     (mouseover)="scrollQues($event)"
                     [fromRoot]="true"
                     [infiniteScrollContainer]="'.scrollPanelSide'"
                     [infiniteScrollDistance]="5"
                     [infiniteScrollThrottle]="50"
                     class="scrollPanelSide card {{env.deviceType() ? 'ml-2' : ''}}"
                     id="scrollinnnersection"
                     infiniteScroll>
                    <div *ngFor="let sec of totalAns; let i = index"
                         [hidden]="totalAns == ''"
                         [ngStyle]="{'padding': showpdf === true ? '1rem' : '2rem' }"
                         class=""
                    >
                        <div *ngIf="sec?.heading != ''" class="col-md-{{showpdf == true ? 12 : 6}} px-0 mb-3">
                            <input [value]="sec?.heading" class="input-custom-modal div-disable" type="text">
                        </div>
                        <div *ngFor="let item of sec?.section; let j = index"
                             [id]="item.page_no + '-' + item.sub_question_no + '-' + j" class="mb-3">
                            <div class="row d-flex justify-content-between">
                                <div class="col-md-2 d-flex">
                                    <button class="btn btn-primary">{{item.sub_question_no}}</button>
                                    <i *ngIf="item.answer_status && item.answer_status != '0' && item.answer_status != '1' && item.answer_status != '4'"
                                       class="fa fa-2x fa-check-circle color-green align-self-center ml-2"></i>
                                    <i *ngIf="item.answer_status == '1'"
                                       class="fa fa-2x fa-times-circle color-red align-self-center ml-2"></i>
                                </div>
                                <div *ngIf="item.question_type_id == '40'" class="col-md-6">
                                    <button (click)="openGraph($event, i, j, item)"
                                            class="btn btn-outline-primary pull-right">answer graph
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mt-4">
                                        <div *ngIf="item.question != ''" [innerHTML]="item.question | sanitizeHtml"
                                             class="mb-0 overflow-auto div-disable" id="{{'questionId'}}"></div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 1">
                                        <div [ngClass]="{'div-disable': getData.student_content_status != '1' && getData.student_content_status != '2'}"
                                             class="row mb-2">
                                            <span (click)="getChooseAns(k, i, j)"
                                                  *ngFor="let option of item.array; let k = index"
                                                  [ngClass]="{'selectColor' : option.trim().toLowerCase() === item.given_answer.trim().toLowerCase() }"
                                                  class="multichoice-option1">{{option}}</span>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 3"
                                         [ngClass]="{'div-disable': getData.student_content_status != '1' && getData.student_content_status != '2'}"
                                         class="d-flex">
                                        <div [ngClass]="{'student-selected': item.given_answer == 'true'}"
                                             class="d-flex align-items-center px-3 py-2">
                                            <input (click)="getTrueAns('true', i , j)"
                                                   [checked]="item?.given_answer == 'true'"
                                                   class="radio-size cursor form-control mr-2"
                                                   id="true{{j}}" name="ans{{j}}" type="radio" value="true">
                                            <label class="mb-0 cursor" for="true{{j}}">True</label>
                                        </div>
                                        <div [ngClass]="{'student-selected': item.given_answer == 'false'}"
                                             class="d-flex align-items-center ml-2 px-3 py-2">
                                            <input (click)="getTrueAns('false', i , j)"
                                                   [checked]="item?.given_answer == 'false'"
                                                   class="radio-size cursor form-control mr-2"
                                                   id="false{{j}}" name="ans{{j}}" type="radio" value="false">
                                            <label class="mb-0 cursor" for="false{{j}}">False</label>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 9"
                                         [ngClass]="{'div-disable': getData.student_content_status != '1' && getData.student_content_status != '2'}">
                                        <div (click)="getDropdownAns(k, i, j)"
                                             *ngFor="let option of item.mob_options; let k = index"
                                             [ngClass]="{'student-selected': option == item.given_answer}"
                                             class="dropdown-list col-md-{{showpdf == true ? 12 : 5}} mb-2 p-2">
                                            <span>{{option}}</span></div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 10" class="col-md-12 mt-4 px-0">
                                    <textarea (input)="getInputAns($event, i, j)"
                                              [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                              [value]="item.given_answer"
                                              class="form-control mt-2 col-md-{{showpdf == true ? 12 : 5}}"
                                              placeholder="Enter answer here" rows="2"
                                    ></textarea>
                                    </div>
                                    <div *ngIf="item.question_type_id == 20" class="col-md-12 mt-4 px-0">
                                        <textarea (input)="getInputAns($event, i, j)"
                                                  [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                  [value]="item.given_answer" class="form-control" cols="30"
                                                  rows="8"></textarea>
                                    </div>
                                    <div *ngIf="item.question_type_id == 30" class="col-md-12 mt-2 px-0">
                                        <app-tiny-mice (emitEditorValue)="getNumericAnswerValue($event, i, j)"
                                                       *ngIf="hideRuleAnswer[i]?.section[j]"
                                                       [editorPatchValue]="item.given_answer == '' ? false : item.given_answer"
                                                       [height]="250"
                                                       [id]="i+'giveAns'+j"
                                                       [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                       [showDropBtn]="false"
                                                       [showInputBtn]="false"
                                                       class="mt-2">
                                        </app-tiny-mice>
                                        <div class="d-flex justify-content-start">
                                            <button (click)="setAnswer(i, j)"
                                                    *ngIf="!hideRuleAnswer[i]?.section[j] && item.question_type_id == 30 && item.given_answer == ''"
                                                    [disabled]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                    class="btn-sm mb-1 btn-outline-primary mr-2">Add Answer
                                            </button>
                                            <button (click)="setAnswer(i, j)"
                                                    *ngIf="!hideRuleAnswer[i]?.section[j] && item.question_type_id == 30 && item.given_answer != ''"
                                                    [disabled]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                    class="btn-sm mb-1 btn-outline-primary mr-2">Edit Answer
                                            </button>
                                            <!--                                            <button (click)="submitAnswer(item.given_answer1 , i ,j)" *ngIf="hideRuleAnswer[i].section[j] && item.question_type_id == 30"-->
                                            <!--                                                    [disabled]="getData.student_content_status != '1' && getData.student_content_status != '2'"-->
                                            <!--                                                    class="btn-sm mb-1 btn-outline-primary mr-2">Submit Answer</button>-->
                                        </div>
                                        <div *ngIf="!hideRuleAnswer[i].section[j]"
                                             class="d-flex mt-2 ml-2 justify-content-start">
                                            <div class="flex-column" style="overflow-y: auto;">
                                                <p style="margin-bottom: 0px;">Answer :</p>
                                                <span *ngIf="!hideRuleAnswer[i].section[j] && item.given_answer != ''"
                                                      [innerHTML]="item.given_answer | sanitizeHtml" class=""
                                                      style="overflow-y: auto;"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <!--                                <div *ngIf="item.question_type_id == '40'">-->
                                    <!--                                    <app-graph-component [editMode]="false"-->
                                    <!--                                                         [editPatchValue]="false"-->
                                    <!--                                                         [graphId]="'previewGraph'"-->
                                    <!--                                                         [questionType]="'40'"></app-graph-component>-->
                                    <!--                                </div>-->
                                    <div *ngIf="item.question_type_id == 54" class="col-md-12 mt-4 px-0">
                                        <div *ngFor="let opt of item.answer; let k = index">
                                        <textarea (input)="getBlanksValue($event, k, i, j)"
                                                  [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                  [value]="item.given_answer[k] ? item.given_answer[k] : ''"
                                                  class="form-control mb-2" placeholder="Enter input-{{k+1}} answer"
                                                  rows="2"
                                        ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item.question_type_id != '40'" class="row mt-3 d-flex">
                                <div class="col-md-12">
                                    <button [attr.aria-controls]="'#queries' + j + 'id' + i"
                                            [attr.data-target]="'#queries' + j + 'id' + i"
                                            [disabled]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                            aria-expanded="false" class="btn-sm btn-outline-primary mr-2"
                                            data-toggle="collapse">Feedback
                                    </button>
                                    <button (click)="toggle(i , j)" class="btn-sm btn-outline-primary mr-2">work space
                                    </button>
                                    <button (click)="openWorkArea(item, i, j)" class="btn-sm mb-1 btn-outline-primary"
                                            title="Work Area">Work area
                                    </button>
                                    <button *ngIf="item.question_type_id == '20'" (click)="expandFullScreen(item, i, j)"
                                            class="btn-sm mb-1 btn-outline-primary" style="width: 30px;"
                                            title="Expand Editor"><i aria-hidden="true" class="fa fa-expand"></i>
                                    </button>
                                    <button (click)="expandFullScreen(item, i, j)"
                                            *ngIf="item.question_type_id == '30' && hideRuleAnswer[i].section[j]"
                                            class="btn-sm mb-1 btn-outline-primary mr-2" style="width: 30px;"
                                            title="Expand Editor"><i aria-hidden="true" class="fa fa-expand"></i>
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="item.question_type_id != '40'" class="row mt-3 mb-3">
                                <div class="col-md-12 collapse" id="queries{{j}}id{{i}}">
                                    <textarea (input)="getQueries($event, i, j, 'pdf')" [value]="item.student_feedback"
                                              class="form-control" placeholder="Feedback" rows="3"></textarea>
                                </div>
                            </div>
                            <div *ngIf="item.question_type_id != '40'" class="row mt-3 d-flex">
                                <div class="col-md-12">
                                    <button (click)="submitQueries(i, j, 'pdf')"
                                            *ngIf="queries != '' && queriesIndex == j+'id'+i"
                                            class="btn-sm btn-primary mr-2 {{env.deviceType() ? 'border-radius-5' : ''}}">
                                        Submit
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="item.question_type_id != '40'" class="row mt-3 mb-3">
                                <div *ngIf="this.hideRuleContent[i]?.section[j] == true" class="col-md-12"
                                     id="workspace{{j}}id{{i}}">
                                    <app-tiny-mice (emitEditorValue)="getNumericWorkSpaceValue($event, i, j)"
                                                   *ngIf="this.hideRuleContent[i].section[j] == true"
                                                   [editorPatchValue]="item.student_roughdata"
                                                   [height]="250"
                                                   [id]="i+'workspace'+j"
                                                   [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                   [showDropBtn]="false"
                                                   [showInputBtn]="false">
                                    </app-tiny-mice>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mt-3 card p-4">
                <textarea [(ngModel)]="totalFeedBack"
                          [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                          class="form-control" cols="30" placeholder="Overall Feedback" rows="5"></textarea>
            </div>
        </div>
        <!--        <div *ngIf="this.questionData.answers.length == 0" class="col-12">-->
        <!--            <div class="col-md-12 mt-3 card p-4">-->
        <!--                <textarea [(ngModel)]="totalFeedBack" [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'" class="form-control" cols="30" placeholder="Overall Feedback" rows="5"></textarea>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>

    <div class="row" *ngIf="!showpdf">
        <div class="col-12 mr-0 pr-0 pb-2" *ngIf="totalAns.length > 1">
            <div class="scoll-component">
                <div class="total-items">
                    <span>{{totalAns.length}} Questions</span>
                </div>
                <div class="scoll-container">
                    <div #scrollContent id="scrollContent" class="scroll-content" (scroll)="onScroll()">
                        <button #leftArrow class="arrow left-arrow arrowStyle" (click)="onClickScrollLeft()"><<</button>

                        <div class="scroll-items" *ngFor="let list of totalAns; let i = index" id="questionNo{{i}}">
                            <span class="round-question pl-2 pr-2 pt-1 pb-1 ml-3 my-2"
                                  (click)="checkWhetherSaveIsNeeded(list, i, 'qnsNumber')"
                                  [ngClass]="{'bg-green':checkQuestionId(list)?.is_correct == 'true', 'bg-partially': checkQuestionId(list)?.is_correct == 'partially-completed' || checkQuestionId(list)?.is_correct == 'manual',
                                  'bg-red':checkQuestionId(list)?.is_correct == 'false' || !correctAnswer, 'black':(checkQuestionId(list)?.is_correct == '' || checkQuestionId(list)?.is_correct == null) && showQuestion != i,
                                  'selectedQuestion':(checkQuestionId(list)?.is_correct == '' || checkQuestionId(list)?.is_correct == null) && showQuestion == i }">
                                {{i + 1}}
                            </span>
                        </div>

                        <button #rightArrow class="arrow right-arrow arrowStyle" (click)="onClickScrollRight()">>>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 mb-0 pl-0" *ngIf="questionData.file_text != ''">
            <div class="card ml-3 mr-0"
                 style="overflow-y: auto; max-height: 25vh; border-bottom: 3px solid #e6baea !important; border-right: 3px solid #e6baea !important">
                <div class="card-body py-3 px-4">
                    <h4 class="mb-3 font-weight-bold">Description:</h4>
                    <div class="ml-2">
                        <span [innerHTML]="questionData.file_text | sanitizeHtml"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section *ngIf="!showpdf">
        <div class="row view-question" *ngFor="let item of totalAns; let i = index; let last = last">
            <div class="px-0 mb-2 {{isSingleQnsWithFeedbackType ? 'col-md-12' :
                totalAns.length == 1 && totalAns[0].question_type_id != '55' ? 'col-md-9' : 'col-md-9'}}" *ngIf="showQuestion == i">
                <div class="container-fluid">
                    <div *ngIf="checkQuestionId(item)?.is_correct == 'true' || checkQuestionId(item)?.is_correct == 'false' || !correctAnswer">
                        <div class="alert alert-{{checkQuestionId(item)?.is_correct == 'false'|| !correctAnswer ? 'danger' : 'success'}} alert-dismissible fade show">
                            <strong> {{checkQuestionId(item)?.is_correct == 'false' || !correctAnswer ? 'You have entered Incorrect Answer !' : 'Great Response ! You have entered Correct Answer'}}</strong>
                            .
                        </div>
                    </div>
                    <div class="card p-5">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-12" *ngIf="item.question_type_id != 24">
                                    <div class="row">
                                        <div style="width: 4%">
                                            <button class="btn-primary px-2 py-1">{{i + 1}}</button>
                                        </div>
                                        <div style="width: 96%">
                                            <div class="inner" *ngIf="item.question != '' && item.question_type_id != 24 && item.question_type_id != 55">
                                                <b><h3 [innerHTML]="item.question | sanitizeHtml" class="mb-0 overflow-auto"></h3></b>
                                            </div>
                                            <div class="inner" *ngIf="item.question != '' && item.question_type_id == 55">
                                                <div ngbAccordion  class="question_type">
                                                    <div ngbAccordionItem="{{item.question_type_id}}" #accordion="ngbAccordionItem" [collapsed]="false">
                                                        <h2 ngbAccordionHeader>
                                                            <button class="btn btn-link d-flex align-items-center justify-content-between p-2 w-100"
                                                                    ngbAccordionToggle>
                                                                <h4 style="font-size: 16px" class="m-0" [innerHTML]="convertMarkdownToHtml(item.question, accordion.collapsed ? 20 : 0)"></h4>
                                                                <div class="d-flex align-items-center justify-content-between">
                                                                    <i *ngIf="accordion.collapsed; else uparrow" aria-hidden="true" class="fa fa-caret-down"></i>
                                                                </div>
                                                                <ng-template #uparrow><i aria-hidden="true" class="fa fa-caret-up"></i></ng-template>
                                                            </button>
                                                        </h2>

                                                        <div ngbAccordionCollapse>
                                                            <div ngbAccordionBody>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12" *ngIf="item.question_type_id == 24">
                                    <div class="row">
                                        <button style="width: 5%; height: 30px" class="btn-primary w-auto h-20 px-2 py-1">{{i + 1}}</button>
                                        <div style="width: 95%;">
                                            <div *ngIf="item.editor_context != ''" class="mx-3 question-page1 px-3 py-2"
                                                 style="overflow-x: scroll;max-height: 60vh; border: 2px solid #e6baea !important;border-radius: 4px;">
                                        <span [innerHTML]="item.editor_context | sanitizeHtml"
                                              class="innerhtml-margin-clear"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div *ngIf="item.question_type_id == 1 || item.question_type_id == 2"
                                         [ngClass]="{'div-disable': checkDisableConditionForQns(item)}" class="mt-4">
                                        <div class="col-md-12 mb-2">
                                            <div (click)="cfsGetMultiChoice(i, k, item)"
                                                 *ngFor="let option of item.given_answer; let k = index"
                                                 [ngClass]="{'student-selected' : k.toString() == option.isSelected}"
                                                 class="dropdown-list overflow-auto col-md-5 mb-3 mx-3 p-2"
                                                 style="max-height: 20rem"><span [innerHTML]="option.options | sanitizeHtml"
                                                                                 class="remove-margin-bottom"></span></div>
                                        </div>
                                        <div class="col-md-12 mt-4 mb-2"
                                             *ngIf="item.is_correct == 'true' || item.is_correct == 'false'">
                                            <label><strong>Correct Answer</strong></label>
                                            <div *ngFor="let option of item.answer; let k = index"
                                                 [ngClass]="{'student-selected' : option.correctAnswer == 'on'}"
                                                 class="dropdown-list col-md-5 mb-3 mx-3 p-2 overflow-y-scroll"
                                                 style="max-height: 20rem">
                                            <span [innerHTML]="item.options[k].options | sanitizeHtml"
                                                  class="remove-margin-bottom"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 5 || item.question_type_id == 7"
                                         [ngClass]="{'div-disable': checkDisableConditionForQns(item)}"
                                         class="mt-4 px-3 table-flexible">
                                        <table class="table table-bordered text-center">
                                            <thead>
                                            <tr>
                                                <th>Questions</th>
                                                <th *ngFor="let list of item.answer; let k=index"
                                                    [innerHTML]="list | sanitizeHtml" class="remove-margin-bottom"
                                                    id="{{'columnId' + i}}"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let list of item.given_answer; let j=index">
                                                <td [innerHTML]="list.options | sanitizeHtml"
                                                    class="remove-margin-bottom"></td>
                                                <td *ngFor="let ans of item.answer; let k=index">
                                                    <input (click)="cfsGetChooseTable(item, i, j, k)"
                                                           *ngIf="item.question_type_id == '5'"
                                                           [checked]="this.totalAns[i].given_answer[j].isSelected == '' ? false : this.totalAns[i].given_answer[j].isSelected == k.toString()"
                                                           class="cursor radio_animated" id="{{j}}chooseSingle{{i}}"
                                                           name="{{i}}choosesingle{{j}}corect" type="radio">
                                                    <input (click)="cfsGetChooseTable(item, i, j, k)"
                                                           *ngIf="item.question_type_id == '7'"
                                                           [checked]="splitMultiChoose(this.totalAns[i].given_answer[j].isSelected, k)"
                                                           id="{{j}}chooseMulti{{i}}" class="cursor" type="checkbox">
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>


                                        <div class="col-md-12 my-4 px-0 table-flexible"
                                             *ngIf="item.is_correct == 'true' || item.is_correct == 'false'">
                                            <label><strong>Correct Answer</strong></label>
                                            <table class="table table-bordered text-center div-disable">
                                                <thead>
                                                <tr>
                                                    <th>Questions</th>
                                                    <th *ngFor="let list of item.answer; let k=index"
                                                        [innerHTML]="list | sanitizeHtml" class="remove-margin-bottom"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let list of item.given_answer; let j=index">
                                                    <td [innerHTML]="list.options | sanitizeHtml"
                                                        class="remove-margin-bottom"></td>
                                                    <td *ngFor="let ans of item.answer; let k=index">
                                                        <input *ngIf="item.question_type_id == '5'"
                                                               [checked]="item.heading_option[j].correctActive === k"
                                                               class="radio_animated"
                                                               name="{{i}}choosesingleCorrect{{j}}corect" type="radio">
                                                        <input *ngIf="item.question_type_id == '7'"
                                                               [checked]="patchCorrectMultiChoiceAnswer(item.heading_option, k , j)"
                                                               id="chooseMultipass{{i}}{{j}}{{k}}" type="checkbox">
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                    <div *ngIf="item.question_type_id == 9" class="mt-4"
                                         [ngClass]="{'div-disable': checkDisableConditionForQns(item)}">
                                        <div *ngFor="let data of item.given_answer; let j = index"
                                             class="col-md-6 mt-3 mb-3">
                                            <label>Dropdown - {{j + 1}}</label>
                                            <div class="col-md-11 dropdown">
                                                <button type="button" [id]="i + 'dropdown' + j"
                                                        [innerHTML]="data.isSelected === '' ? 'Select Answer' : data.options[data.isSelected].correctAnswer | sanitizeHtml"
                                                        class="col-md-12 bg-white innerhtml-margin-clear p-2 dropdown-border dropdown-toggle d-flex justify-content-between"
                                                        data-toggle="dropdown"></button>
                                                <div class="col-md-11 dropdown-menu">
                                                <span (click)="cfsGetDropdown($event, i, j, '', 'Select Answer')"
                                                      class="dropdown-item dropdown-link cursor">Select Answer</span>
                                                    <span (click)="cfsGetDropdown($event, i, j, k, list.listOption)"
                                                          *ngFor="let list of data.options; let k = index"
                                                          [innerHTML]="list.listOption | sanitizeHtml"
                                                          class="dropdown-item dropdown-link innerhtml-margin-clear"
                                                          style="overflow: scroll; overflow-y: hidden"></span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 mt-5 px-0"
                                             *ngIf="item.is_correct == 'true' || item.is_correct == 'false'">
                                            <label><b>Correct Answer</b></label>
                                            <div *ngFor="let data of item.answer; let j = index" class="col-md-6 mt-2 mb-3">
                                                <label>Dropdown - {{j + 1}}</label>
                                                <div class="col-md-11">
                                                    <div class="col-md-12 bg-white innerhtml-margin-clear p-2 dropdown-border dropdown-toggle d-flex justify-content-between"
                                                         data-toggle="dropdown" id="dropdown{{j}}"></div>
                                                    <div class="col-md-12 dropdown-menu">
                                                        <span class="dropdown-item dropdown-link overflow-auto">Select Answer</span>
                                                        <span *ngFor="let option of item.options; let k = index"
                                                              [innerHTML]="option.listOption | sanitizeHtml"
                                                              class="dropdown-item overflow-auto dropdown-link innerhtml-margin-clear"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 10" class="mt-4"
                                         [ngClass]="{'div-disable': checkDisableConditionForQns(item)}">
                                        <div *ngFor="let data of item.given_answer; let j = index"
                                             class="col-md-6 mt-3 mb-3">
                                            <label>Input - {{j + 1}}</label>
                                            <input (input)="cfsGetInput($event, i, j, item)" *ngIf="item.editor_type == 1"
                                                   placeholder="Enter the Answer"
                                                   [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                   [value]="data.isSelected" class="form-control" type="text">
                                            <app-tiny-mice (emitEditorValue)="cfsGetInput($event, i, j, item)"
                                                           *ngIf="item.editor_type != 1"
                                                           [editorPatchValue]="data.isSelected == '' ? false : data.isSelected"
                                                           [height]="100"
                                                           [id]="i+'input'+j"
                                                           [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                           [showDropBtn]="false"
                                                           [showInputBtn]="false"
                                                           class="mt-2">
                                            </app-tiny-mice>
                                        </div>

                                        <div class="col-md-12 mt-5 px-0"
                                             *ngIf="item.is_correct == 'true' || item.is_correct == 'false'">
                                            <label><b>Correct Answer</b></label>
                                            <div *ngFor="let data of item.options; let j = index"
                                                 class="col-md-6 mt-3 mb-3">
                                                <label>Input - {{j + 1}}</label>
                                                <div class="form-span">
                                                    <div [innerHTML]="data.options[0].value | sanitizeHtml"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 16" class="mt-4"
                                         [ngClass]="{'div-disable': checkDisableConditionForQns(item)}">
                                        <div class="col-md-6">
                                            <div (cdkDropListDropped)="droppedCorrect($event, i)" cdkDropList
                                                 class="col-12">
                                                <div *ngFor="let list of item.given_answer; let k=index"
                                                     class="input-group mb-3 mt-3 inputMenu">
                                                    <div cdkDrag class="input-group mb-1 inputMenu">
                                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <img class="img-fluid" src="assets/images/pdf-icons/equal@2x.png">
                                            </span>
                                                        </div>
                                                        <h4 [innerHTML]="list.options | sanitizeHtml"
                                                            class="form-control mb-0 pt-4 pb-5 overflow-auto"></h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 mt-5"
                                             *ngIf="item.is_correct == 'true' || item.is_correct == 'false'">
                                            <label><b>Correct Answer</b></label>
                                            <div class="col-6">
                                                <div *ngFor="let list of item.answer; let k=index"
                                                     class="input-group mb-3 mt-3 inputMenu">
                                                    <div class="input-group mb-1 inputMenu">
                                                        <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <img alt="Equal To" class="img-fluid" src="assets/images/pdf-icons/equal@2x.png">
                                        </span>
                                                        </div>
                                                        <h4 [innerHTML]="list.correctAnswer | sanitizeHtml"
                                                            class="form-control mb-0 pt-4 pb-5 overflow-auto"></h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="['20'].indexOf(item.question_type_id) > -1" class="mt-4 px-3 mb-3"
                                         [ngClass]="{'div-disable': checkDisableConditionForQns(item)}">
                                        <app-tiny-mice (emitEditorValue)="cfsGetPara($event, i)"
                                                       [editorPatchValue]="item.given_answer[0].isSelected == '' ? false : item.given_answer[0].isSelected"
                                                       [height]="120"
                                                       [id]="i+'para'"
                                                       [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                       [showDropBtn]="false"
                                                       [showInputBtn]="false"
                                                       class="mt-2">
                                        </app-tiny-mice>
                                        <div class="col-md-12 mt-5 px-0" *ngIf="item.is_correct == 'true' || item.is_correct == 'false'">
                                            <label><b>Correct Answer</b></label>
                                            <div *ngFor="let data of item.answer; let j = index"
                                                 class="col-md-6 mt-3 mb-3">
                                                <label>Answer - {{j + 1}}</label>
                                                <div class="form-span">
                                                    <div [innerHTML]="data.correctAnswer | sanitizeHtml"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-4 row ml-4 pl-3" *ngIf="['55'].indexOf(item.question_type_id) > -1" >
                                        <div class="text-area pl-0 col-{{previousFeedBack.length == 0 ? '12' : '9'}}">
                                            <textarea class="form-control" rows="{{previousFeedBack.length < maximumAllowedCount ? '24' : '21'}}" [(ngModel)]="selectedFeedBackIndex != 0 && selectedFeedBackIndex != '' ? selectedPreviousStudentAnswer?.student_answer : item.given_answer[0].isSelected"
                                                      [readonly]="selectedFeedBackIndex != 0 && selectedFeedBackIndex != '' || (getData.student_content_status != '1' && getData.student_content_status != '2')"
                                                      [ngModelOptions]="{standalone: true}" placeholder="Please enter your answer"></textarea>
                                            <div class="word-count">
                                                <span class="mr-2">{{wordCount(item)}}&nbsp;Words</span>
                                            </div>
                                        </div>
                                        <div class="col-3" *ngIf="previousFeedBack.length != 0">
                                            <div class="col-12 sidebar-widget">
                                                <h5 class="font-weight-bold">Version History</h5>
                                                <ul class="widget-post pt-15">
                                                    <li (click)="feedbackSelected('current')" *ngIf="!feedbackServiceCalled" [ngClass]="{'active': selectedFeedBackIndex === ''}">
                                                        <a>Current Version</a>
                                                    </li>
                                                    <li *ngFor="let feedback of previousFeedBack; let i = index" [ngClass]="{'active': selectedFeedBackIndex === previousFeedBack.length - i}"
                                                        (click)="feedbackSelected(feedback)">
                                                        <a class="d-flex align-items-center justify-content-between">Version {{previousFeedBack.length - i}}
                                                            <span class="badge" [ngClass]="{'badge-exceptional': getFeedbackLabel(feedback).label === 'Exceptional', 'badge-good': getFeedbackLabel(feedback).label === 'Good',
                                                                'badge-improve': getFeedbackLabel(feedback).label === 'Improve'}">{{getFeedbackLabel(feedback).label}}</span></a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-12 resource-link-card mt-3" *ngIf="previousFeedBack.length < maximumAllowedCount">
                                                <span class="text-info">You can use Request For Feedback
                                                    <strong>&nbsp;{{maximumAllowedCount - previousFeedBack.length}}&nbsp;</strong>more times!
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 24" class="mt-4"
                                         [ngClass]="{'div-disable': checkDisableConditionForQns(item)}">
                                        <div *ngFor="let sec of item.subQuestions; let j = index" class="mb-3">
                                            <div class="row d-flex justify-content-start">
                                                <div>
                                                    <button class="btn-outline-primary question-no-big">{{j + 1}}</button>
                                                </div>
                                                <div class="pl-4 align-self-center passage-inner"
                                                     [innerHTML]="sec.question | sanitizeHtml"></div>
                                            </div>
                                            <div *ngIf="sec.question_type_id == '1' || sec.question_type_id == '2'"
                                                 class="mt-3">
                                                <div [ngClass]="{'div-disable': getData.student_content_status != '1' && getData.student_content_status != '2'}"
                                                     class="row mb-2">
                                                    <div (click)="cfsPassageMultiChoice(i, j, k, sec)"
                                                         *ngFor="let option of sec.given_answer; let k = index"
                                                         [ngClass]="{'student-selected' : option.isSelected == k.toString()}"
                                                         class="dropdown-list overflow-auto col-md-6 mb-3 mx-3 p-2"
                                                         style="max-height: 20rem"><span
                                                            [innerHTML]="option.options | sanitizeHtml"
                                                            class="remove-margin-bottom"></span></div>
                                                </div>
                                                <div class="col-md-12 mt-4 mb-2 px-0"
                                                     *ngIf="sec.is_correct == 'true' || sec.is_correct == 'false'">
                                                    <label><strong>Correct Answer :</strong></label>
                                                    <div *ngFor="let option of sec.answer; let k = index"
                                                         [ngClass]="{'student-selected' : option.correctAnswer !== ''}"
                                                         class="dropdown-list col-md-6 mb-3 mx-3 p-2 overflow-y-scroll"
                                                         style="max-height: 20rem">
                                                    <span [innerHTML]="sec.options[k].options | sanitizeHtml"
                                                          class="remove-margin-bottom"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="sec.question_type_id == '5' || sec.question_type_id == '7'"
                                                 class="table-flexible">
                                                <table [ngClass]="{'div-disable': getData.student_content_status != '1' && getData.student_content_status != '2'}"
                                                       class="table px-3 table-bordered text-center mt-3 mb-3">
                                                    <thead>
                                                    <tr>
                                                        <th>Questions</th>
                                                        <th *ngFor="let list of sec.answer; let l=index"
                                                            [innerHTML]="list | sanitizeHtml"
                                                            class="remove-margin-bottom"></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr *ngFor="let list of sec.given_answer; let k=index">
                                                        <td [innerHTML]="list.options" class="remove-margin-bottom"></td>
                                                        <td *ngFor="let ans of sec.answer; let l=index">
                                                            <input (click)="cfsGetChooseTable(sec, j, k, l)"
                                                                   *ngIf="sec.question_type_id == '5'"
                                                                   [checked]="sec.given_answer[k].isSelected == '' ? false : sec.given_answer[k].isSelected == l.toString()"
                                                                   class="radio_animated" name="{{i}}choose{{k}}passas{{j}}"
                                                                   type="radio">
                                                            <input (click)="cfsGetChooseTable(sec, j, k, l)"
                                                                   *ngIf="sec.question_type_id == '7'"
                                                                   [checked]="splitMultiChoose(sec.given_answer[k].isSelected, l)"
                                                                   type="checkbox">
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>

                                                <div class="col-md-12 my-4 px-0 table-flexible"
                                                     *ngIf="sec.is_correct == 'true' || sec.is_correct == 'false'">
                                                    <label><strong>Correct Answer :</strong></label>
                                                    <table class="table table-bordered text-center div-disable">
                                                        <thead>
                                                        <tr>
                                                            <th>Questions</th>
                                                            <th *ngFor="let list of sec.answer; let k=index"
                                                                [innerHTML]="list | sanitizeHtml"
                                                                class="remove-margin-bottom"></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr *ngFor="let list of sec.given_answer; let j=index">
                                                            <td [innerHTML]="list.options | sanitizeHtml"
                                                                class="remove-margin-bottom"></td>
                                                            <td *ngFor="let ans of sec.answer; let k=index">
                                                                <input *ngIf="sec.question_type_id == '5'"
                                                                       [checked]="sec.heading_option[j].correctActive === k"
                                                                       class="radio_animated"
                                                                       name="{{i}}choosesingleCorrect{{j}}corect"
                                                                       type="radio">
                                                                <input *ngIf="sec.question_type_id == '7'"
                                                                       [checked]="patchCorrectMultiChoiceAnswer(sec.heading_option, k , j)"
                                                                       id="chooseMultipass{{i}}{{j}}{{k}}" type="checkbox">
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div *ngIf="sec.question_type_id == '10'">
                                                <div *ngFor="let data of sec.given_answer;let k = index"
                                                     class="col-md-6 mt-3 mb-3 px-1">
                                                    <label>Input - {{k + 1}}</label>
                                                    <input (input)="cfsGetInput($event, j, k, sec)"
                                                           *ngIf="sec.editor_type == 1"
                                                           [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                           [value]="data.isSelected" class="form-control" type="text">
                                                    <app-tiny-mice (emitEditorValue)="cfsGetInput($event, j, k, sec)"
                                                                   *ngIf="sec.editor_type != 1"
                                                                   [editorPatchValue]="data.isSelected == '' ? false : data.isSelected"
                                                                   [height]="120"
                                                                   [id]="j+'inputPass'+k+'ssa'+i"
                                                                   [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                                   [showDropBtn]="false"
                                                                   [showInputBtn]="false"
                                                                   class="mt-2">
                                                    </app-tiny-mice>
                                                </div>

                                                <div class="col-md-12 mt-5 px-0"
                                                     *ngIf="sec.is_correct == 'true' || sec.is_correct == 'false'">
                                                    <label><b>Correct Answer</b></label>
                                                    <div *ngFor="let data of sec.options; let j = index"
                                                         class="col-md-6 mt-3 mb-3">
                                                        <label>Input - {{j + 1}}</label>
                                                        <div class="form-span">
                                                            <div [innerHTML]="data.options[0].value | sanitizeHtml"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="sec.question_type_id == '20'" class="mt-3 mb-2">
                                                <app-tiny-mice (emitEditorValue)="cfsGetPassageEssay($event, j, sec)"
                                                               [editorPatchValue]="sec.given_answer[0]?.isSelected == '' ? false : sec.given_answer[0]?.isSelected"
                                                               [height]="200"
                                                               [id]="j+'essayPass'"
                                                               [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                               [showDropBtn]="false"
                                                               [showInputBtn]="false"
                                                               class="mt-2">
                                                </app-tiny-mice>
                                                <div class="col-md-12 mt-5 px-0" *ngIf="sec.is_correct == 'true' || sec.is_correct == 'false'">
                                                    <label><b>Correct Answer</b></label>
                                                    <div *ngFor="let data of sec.answer; let j = index"
                                                         class="col-md-6 mt-3 mb-3">
                                                        <label>Answer - {{j + 1}}</label>
                                                        <div class="form-span">
                                                            <div [innerHTML]="data.correctAnswer | sanitizeHtml"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="item.question_type_id == 28" class="mt-4 px-3 mb-3">
                                        <app-tiny-mice (emitEditorValue)="cfsGetHighlight($event, i)"
                                                       [editorPatchValue]="item.given_answer[0]?.isSelected == '' ? item.options[0].options : item.given_answer[0]?.isSelected"
                                                       [height]="120"
                                                       [id]="i+'delta'"
                                                       [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                       [showDropBtn]="false"
                                                       [showInputBtn]="false"
                                                       class="mt-2">
                                        </app-tiny-mice>
                                    </div>
                                    <div *ngIf="item.question_type_id == 40 || item.question_type_id == 41"
                                         class="mt-4 mb-4">
                                        <div class="col-12 mt-0 d-flex justify-content-center">
                                            <app-graph-component (valueChange)="cfsgetGraphValue($event, i)"
                                                                 [editMode]="getData.student_content_status == '1' || getData.student_content_status == '2'"
                                                                 [editPatchValue]="item.given_answer[0].correctAnswer ? parseVal(item.given_answer[0].correctAnswer) : false"
                                                                 [graphId]="'graphAnswering'+i"
                                                                 [questionType]="item.question_type_id"></app-graph-component>
                                        </div>
                                        <div class="col-md-12 mt-2">
                                            <app-tiny-mice (emitEditorValue)="cfsGetGraghEditor($event, i)"
                                                           [editorPatchValue]="item.student_editor_answer == '' ? false : item.student_editor_answer"
                                                           [height]="120"
                                                           [id]="i+'explaino'"
                                                           [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                           [showDropBtn]="false"
                                                           [showInputBtn]="false"
                                                           class="mt-2">
                                            </app-tiny-mice>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

<!--                        <div class="row mt-4 d-flex justify-content-end"-->
<!--                             *ngIf="getData.student_content_status != '1' && getData.student_content_status != '2' && previousFeedBack.length != 0">-->
<!--                            <select class="form-control select-design pull-right" (click)="feedbackSelected($event.target.value)">-->
<!--                                <option value="" selected disabled>Previous Feedbacks ({{previousFeedBack.length}})</option>-->
<!--                                <option value="current">Current Version</option>-->
<!--                                <option [value]="feedback | json"  *ngFor="let feedback of previousFeedBack">-->
<!--                                    <a class="cursor">Feedback {{previousFeedBack.length - feedback.index}} <span *ngIf="feedback?.created_date"> ({{feedback?.created_date | customDateFormat}} | {{feedback?.created_date | date:'h:mm a'}}) </span></a>-->
<!--                                </option>-->
<!--                            </select>-->
<!--                        </div>-->

                        <div class="row mt-4 d-flex justify-content-end"
                             *ngIf="getData.student_content_status == '1' || getData.student_content_status == '2'">
                            <div class="col-md-12">

                                <div *ngIf="isSingleQnsWithFeedbackType">
                                    <button class="btn btn-primary ml-3 pull-right" (click)="checkForApiTypeQns()">
                                        Submit For Final</button>

                                    <button class="btn pull-right btn-outline-primary ml-3" (click)="feedbackSelected('current')"
                                            *ngIf="selectedFeedBackIndex != ''">
                                        <i class="fa fa-repeat mr-1" aria-hidden="true"></i>Revise</button>

                                    <button *ngIf="item.question_type_id == 55 && (selectedFeedBackIndex == '' || selectedFeedBackIndex <= 0) && previousFeedBack.length < maximumAllowedCount && questionData?.auto_review != '0'"
                                            (click)="getFeedbackValue(item)" class="btn btn-outline-primary pull-right ml-3">
                                        <i class="fa fa-comments mr-1" aria-hidden="true"></i>Request For Feedback ({{previousFeedBack.length}} / {{maximumAllowedCount}})
                                    </button>

                                    <button *ngIf="getData.student_content_status == '1' || getData.student_content_status == '2'"
                                            class="btn pull-right btn-outline-primary ml-3"  (click)="saveAnswer('2', 'noExit', true, 'same')">
                                        <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>Save</button>

                                    <button *ngIf="getData.student_content_status == '1' || getData.student_content_status == '2'"
                                            class="btn pull-right btn-outline-primary" (click)="saveAnswer('2', 'exit', true, 'same')">
                                        <i class="fa fa-sign-out mr-1" aria-hidden="true"></i>Save & Exit</button>

                                </div>

                                <button *ngIf="!isSingleQnsWithFeedbackType" class="btn pull-right btn-primary ml-3" (click)="checkLastQuestion(i, last)">
                                    Next <i class="fa fa-long-arrow-right ml-1"></i></button>
                                <button class="btn pull-right btn-outline-primary" (click)="tryAgainButton()"
                                        *ngIf="checkQuestionId(item)?.is_correct == 'partially-completed' && !tryAgainButtonEnabled">
                                    Try Again <i class="fa fa-repeat ml-1" aria-hidden="true"></i></button>

<!--                                <select *ngIf="previousFeedBack.length != 0" class="form-control select-design pull-right" (click)="feedbackSelected($event.target.value)">-->
<!--                                    <option value="" selected disabled>Previous Feedbacks ({{previousFeedBack.length}})</option>-->
<!--                                    <option value="current">Current Version</option>-->
<!--                                    <option [value]="feedback | json"  *ngFor="let feedback of previousFeedBack">-->
<!--                                        <a class="cursor">Feedback {{previousFeedBack.length - feedback.index}} <span *ngIf="feedback?.created_date"> ({{feedback?.created_date | customDateFormat}} | {{feedback?.created_date | date:'h:mm a'}}) </span></a>-->
<!--                                    </option>-->
<!--                                </select>-->
                            </div>
                        </div>

                        <div class="row" *ngIf="item.question_type_id == 55 && convertedText && convertedText != ''">
                            <div class="col-12 mt-2">
                                <h5 class="font-weight-bold">Feedback {{selectedFeedBackIndex}} <span *ngIf="selectedPreviousStudentAnswer?.created_date"> ({{selectedPreviousStudentAnswer?.created_date | customDateFormat}}  | {{selectedPreviousStudentAnswer?.created_date | date:'h:mm a'}}) </span>:</h5>
                                 <div class="feedback-card" [innerHTML]="convertedText"></div>
                            </div>
                        </div>
                    </div>

                    <div class="card px-3 pt-3 pb-4">
                        <div class="card-body">
                            <div class="row">
                                <label class="ml-2"><strong>{{isSingleQnsWithFeedbackType ? 'Cited Source' : 'WorkSpace'}} :</strong></label>
                                <div class="col-12 px-3">
                                    <app-tiny-mice (emitEditorValue)="getWorkSpaceValue($event, i)"
                                                   [editorPatchValue]="item.PatchData && item.question_type_id != '24' ? item.student_roughdata :
                                            item.PatchData && item.question_type_id == '24' ? item.subQuestions[0]?.student_roughdata :false"
                                                   [height]="140"
                                                   [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                                   [showDropBtn]="false"
                                                   [showInputBtn]="false">
                                    </app-tiny-mice>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card p-3" *ngIf="!isSingleQnsWithFeedbackType">
                        <div class="card-body">
                            <div class="row">
                                <label class="ml-2"><strong>FeedBack :</strong></label>
                                <div class="col-12 px-3">
                                <textarea (input)="getQueries($event, i, 0, 'scratch')"
                                          [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                          [value]="item.question_type_id != '24' ? item.student_feedback : item.subQuestions[0]?.student_feedback"
                                          class="form-control" cols="30" placeholder="Please Enter the Feedback"
                                          rows="3"></textarea>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <button (click)="submitQueries(i, 0, 'scratch')"
                                            *ngIf="queries != '' && queriesIndex == 'id'+i"
                                            class="pull-right btn btn-primary {{env.deviceType() ? 'border-radius-5' : ''}}">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="!isSingleQnsWithFeedbackType">
                        <div class="col-12">
                            <label><strong>Overall FeedBack:</strong></label>
                            <textarea [(ngModel)]="totalFeedBack" class="form-control"
                                      [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                      placeholder="Please Enter the Overall Feedback" cols="30" rows="3"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3" *ngIf="showQuestion == i && !isSingleQnsWithFeedbackType">
                <div class="card">
                    <div class="card-body" style="background: #ececec;">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center pr-0">
                                <h5 class="mt-2">Question Answered</h5>
                            </div>
                            <div class="col-12 paddingDetails">
                                <div class="card align-items-center px-4 py-5">
                                    <h4><b>{{numOfQuestionAnswered()}}</b></h4>
                                    <h4></h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body" style="background: #ececec">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <h5 class="mt-2">Time Elapsed</h5>
                            </div>
                            <div class="col-12 paddingDetails">
                                <div class="card align-items-center px-4 py-5">
                                    <h4 *ngIf="getElapsedTime() as elapsed">
                                        <b> {{elapsed.hours}} {{elapsed.minutes}} {{elapsed.seconds}} </b>
                                    </h4>
                                    <h4></h4>
                                    <h5><b>HR MIN SEC</b></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body" style="background: #ececec">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <h5 class="mt-2">Score</h5>
                            </div>
                            <div class="col-12 paddingDetails">
                                <div class="card align-items-center px-4 py-5">
                                    <h4>
                                        <b>{{checkAutoGradeQns == '2' && (getData.student_content_status == '1' || getData.student_content_status == '2') ? percentage : '-'}}</b>
                                    </h4>
                                    <h4></h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<!--<div *ngIf="answerSaving" class="p-2 mb-0 saving saving06">-->
<!--    <span data-text="S">S</span>-->
<!--    <span data-text="A">A</span>-->
<!--    <span data-text="V">V</span>-->
<!--    <span data-text="I">I</span>-->
<!--    <span data-text="N">N</span>-->
<!--    <span data-text="G">G</span>-->
<!--    <span data-text=".">.</span>-->
<!--    <span data-text=".">.</span>-->
<!--    <span data-text=".">.</span>-->
<!--</div>-->
<ng-template #submitAlert let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title letter">Submit {{contentType}}</h4>
    </div>
    <div class="modal-body p-0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <p class="mb-0 my-3" *ngIf="buttonClicked == 'submit'">Once submitted, you will not be able to edit your answers</p>
                    <p class="mb-0 my-3" *ngIf="buttonClicked == ''">Yay! Your final effort and last question are here. The subsequent
                        assignment will be turned in for evaluation after clicking the OK button</p>
                </div>
            </div>
            <!-- Container-fluid Ends-->
        </div>
        <div class="modal-footer d-flex justify-content-right">
            <button (click)="buttonClicked = '';close()"
                    class="btn cancel {{env.deviceType() ? 'border-radius-5' : ''}}" type="button">Cancel
            </button>
            <button *ngIf="isSingleQnsWithFeedbackType && questionData?.auto_review != '0'" (click)="getFeedbackValue(this.totalAns[0], 'saveAndExit');"
                    class="btn btn-primary {{env.deviceType() ? 'border-radius-5' : ''}}" type="button">Ok
            </button>
            <button *ngIf="!(isSingleQnsWithFeedbackType && questionData?.auto_review != '0')" (click)="buttonClicked = '';saveAnswer('4', 'exit', true);"
                    class="btn btn-primary {{env.deviceType() ? 'border-radius-5' : ''}}" type="button">Ok
            </button>
        </div>
    </div>
</ng-template>
<ng-template #answerGraph let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title letter">Answer graph</h4>
    </div>
    <div class="modal-body">

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 mt-4 px-0">
                    <div class="col-md-12">
                        <app-graph-component (valueChange)="storeGraph($event)"
                                             [editMode]="getData.student_content_status == '1' || getData.student_content_status == '2'"
                                             [editPatchValue]="graphAnswerVal == '' ? false : parseVal(graphAnswerVal)"
                                             [graphId]="'deaaa'"
                                             [questionType]="'40'"></app-graph-component>
                        <!--                        <app-graph-component [editMode]="false"-->
                        <!--                                             [editPatchValue]="false"-->
                        <!--                                             [graphId]="'previewG'"-->
                        <!--                                             [questionType]="'40'"></app-graph-component>-->
                    </div>
                </div>
            </div>
            <div class="row mt-3 d-flex">
                <div class="col-md-12">
                    <button [attr.aria-controls]="'#queries' + graphIndex" [attr.data-target]="'#queries' + graphIndex"
                            [disabled]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                            aria-expanded="false" class="btn-sm btn-outline-primary mr-2" data-toggle="collapse">
                        Feedback
                    </button>
                    <button [attr.aria-controls]="'#workspace' + graphIndex"
                            [attr.data-target]="'#workspace' + graphIndex" aria-expanded="false"
                            class="btn-sm btn-outline-primary mr-2" data-toggle="collapse">work space
                    </button>
                    <button (click)="openWorkArea('', graphId, graphIndex)" class="btn-sm mb-1 btn-outline-primary mr-2"
                            title="Work Area">Work area
                    </button>
                    <button [attr.aria-controls]="'#answer'" [attr.data-target]="'#answer'" aria-expanded="false"
                            class="btn-sm btn-outline-primary mr-2" data-toggle="collapse">Set Answer
                    </button>
                </div>
            </div>
            <div class="row mt-3 mb-3">
                <div class="col-md-12 collapse" id="queries{{graphIndex}}">
                    <textarea (input)="getQueries($event, graphId, graphIndex, 'pdf')" [value]="graphFeedback"
                              class="form-control" placeholder="Feedback" rows="3"></textarea>
                </div>
            </div>
            <div class="row mt-3 d-flex">
                <div class="col-md-12">
                    <button (click)="submitQueries(graphId, graphIndex, 'pdf')"
                            *ngIf="queries != '' && queriesIndex == graphIndex+'id'+graphId"
                            class="btn-sm btn-primary mr-2">Submit
                    </button>
                </div>
            </div>
            <div class="row mt-3 mb-3">
                <div class="col-md-12 collapse" id="workspace{{graphIndex}}">
                    <app-tiny-mice (emitEditorValue)="getNumericWorkSpaceValue($event, graphId, graphIndex)"
                                   [editorPatchValue]="this.workspacedata[graphId].section[graphIndex].patchData == false ? false : this.totalAns[graphId].section[graphIndex].student_roughdata"
                                   [height]="250"
                                   [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                   [id]="'workspacing'"
                                   [showDropBtn]="false"
                                   [showInputBtn]="false">
                    </app-tiny-mice>
                </div>
                <div #answer class="col-md-12 collapse" id="answer">
                    <app-tiny-mice (emitEditorValue)="getGraphEditorValue($event)"
                                   [editorPatchValue]="this.graphEditorAnsDup == false ? false : this.graphEditorAns"
                                   [height]="250"
                                   [id]="'answerrr'"
                                   [readonly]="false"
                                   [showDropBtn]="false"
                                   [showInputBtn]="false"
                    >
                    </app-tiny-mice>
                </div>
            </div>
            <!-- Container-fluid Ends-->
        </div>
        <div class="modal-footer d-flex justify-content-right mt-2">
            <button (click)="closeGraph(graphId, graphIndex)"
                    class="btn btn-primary-outline {{env.deviceType() ? 'border-radius-5' : ''}}" type="button">Cancel
            </button>
            <button (click)="getGraphAnswerValue(getGraph, graphId, graphIndex)"
                    class="btn btn-primary {{env.deviceType() ? 'border-radius-5' : ''}}" type="button">Submit
            </button>
        </div>
    </div>
</ng-template>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title font-weight-bold" id="modal-basic-title">Resources</h4>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row" *ngFor="let item of linkdata; let j = index">
                <div class="col-md-12">
                    <a class="cursor" href="{{item.link}}" target="_blank">
                        <span style="overflow: scroll; overflow-y: hidden"
                              title="{{item.link}}">{{item.name != '' ? item.name : item.link}}</span>
                    </a>
                    <hr *ngIf="j != linkdata.length - 1">
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary {{env.deviceType() ? 'border-radius-5' : ''}}" (click)="onSave()">
            Cancel
        </button>
    </div>
</ng-template>
<ng-template #showExpand let-c="close" let-d="dismiss">

    <div class="modal-body" style="border: 0px;">
        <div class="container-fluid">
            <div class="row">
                <!--                <div class="col-sm-12 text-right">-->
                <!--                    <i (click)="close()" class="fa fa-close cursor" style="font-size: 1rem"></i>-->
                <!--                </div>-->
                <div class="row d-flex justify-content-between">
                    <div class="col-md-1 mt-2">
                        <button class="btn btn-primary {{env.deviceType() ? 'border-radius-5' : ''}}">{{showAnswerItem.sub_question_no}}</button>
                    </div>
                </div>
                <div class="col-11 mt-2">
                    <div *ngIf="showAnswerItem.question != ''" [innerHTML]="showAnswerItem.question | sanitizeHtml"
                         class="mb-0 overflow-auto div-disable"></div>
                </div>
                <div class="col-12 mt-2 text-center" *ngIf="showAnswerItem.question_type_id == '30'">
                    <app-tiny-mice class="mt-2"
                                   (emitEditorValue)="getNumericAnswerValue1($event, showAnswerI, showAnswerJ)"
                                   [editorPatchValue]="showAnswerItem.given_answer == '' ? false : showAnswerItem.given_answer1"
                                   [readonly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                                   [height]="250"
                                   [id]="showAnswerI+'giveAnsPop'+showAnswerJ"
                                   [showDropBtn]="false"
                                   [showInputBtn]="false">
                    </app-tiny-mice>
                    <button (click)="patchMinimize(showAnswerI, showAnswerJ, showAnswerItem)"
                            class="btn-sm mb-1 btn-outline-primary mr-2 mt-3">Show minimize Editor
                    </button>
                </div>
                <div class="col-12 mt-2 text-center" *ngIf="showAnswerItem.question_type_id == '20'">
                    <textarea (input)="getInputAns($event, showAnswerI, showAnswerJ)"
                              [readOnly]="getData.student_content_status != '1' && getData.student_content_status != '2'"
                              class="form-control" cols="30" rows="8">{{showAnswerItem.given_answer}}</textarea>
                    <button (click)="patchMinimize(showAnswerI, showAnswerJ, showAnswerItem)"
                            class="btn-sm mb-1 btn-outline-primary mr-2 mt-3">Show minimize Editor
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #feedback let-c="close" let-d="dismiss">
    <div class="modal-header d-flex justify-content-between">
        <h4 class="mb-0" style="color: #8F008A">Overall Feedback</h4><i (click)="close()"
                                                                        class="fa fa-times-circle cursor"
                                                                        style="font-size: 1.2rem"></i>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div class="col-md-12 d-flex mt-4 mb-4 p-4 release-card">
                <span>{{questionData.teacher_feedback}}</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #workArea let-c="close" let-d="dismiss">
    <div class="modal-header d-flex justify-content-between">
        <h4 class="mb-0">Work Area</h4><i (click)="closeWorkArea()" class="fa fa-times-circle cursor"
                                          style="font-size: 1.2rem"></i>
    </div>
    <div class="modal-body" style="border: 0px">
        <div class="container-fluid">
            <div *ngIf="(getData.student_content_status == '1' || getData.student_content_status == '2') && !env.deviceType()">
                <app-annotation (annotate)="getWorkAreaAnnotation($event)"
                                [getAnnotate]="workAnnotate"
                                [id]="'workArea'"
                                [toolAdjust]="true"
                                [toolHide]="true"
                                [userType]="'student'"></app-annotation>
            </div>
            <div *ngIf="(getData.student_content_status == '1' || getData.student_content_status == '2') && env.deviceType()">
                <app-student-web-annotation
                        (annotate)="getWorkAreaAnnotation($event)"
                        [getAnnotate]="workAnnotate"
                        [toolAdjust]="true"
                        [toolHide]="true"
                        [popUp]="true"
                ></app-student-web-annotation>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #feedbackStatus>
    <div class="modal-body">
        <div class="col-12 px-0 my-3 d-flex flex-row align-items-center">
            <div class="feedback_spinner"></div>
            <span class="ml-3" style="font-size: 16px">{{popUpMessage}}</span>
        </div>
    </div>
</ng-template>
